import cn from 'classnames'
import React, { ReactElement } from 'react'
import sanitize from 'sanitize-html'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations'
import { Textarea } from 'core-components/library/inputs'
import { Skeleton } from 'shared/components/skeleton'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './CompetitorsSobComment.module.scss'

interface ICompetitorsSobCommentProps {
  value: string
  onChange?: (value: string) => void
  saveSection?: ReactElement
  className?: string
  showIfOnlyExists?: boolean
  isLoading?: boolean
}

export const CompetitorsSobComment = ({
  value,
  onChange,
  saveSection,
  className,
  showIfOnlyExists,
  isLoading,
}: ICompetitorsSobCommentProps) => {
  if (!value && showIfOnlyExists) {
    return null
  }

  if (isLoading) {
    return <Skeleton className={cn(styles.root, className)} />
  }
  return (
    <div className={cn(styles.root, className)}>
      {onChange ? (
        <div>
          <Textarea
            rows={3}
            value={value}
            onChange={onChange}
            label={<Translation text={TRANSLATION_KEYS.comment} />}
          />
        </div>
      ) : (
        <InfoBlock
          customIconClass={'kbase kbase-chat'}
          type={InfoBlockType.Info}
          text={
            <div>
              <p className={styles.title}>
                <Translation text={TRANSLATION_KEYS.comment} />
              </p>
              <div dangerouslySetInnerHTML={{ __html: sanitize(value) }} />
            </div>
          }
        />
      )}

      {saveSection}
    </div>
  )
}
